module.exports = __webpack_public_path__ + "img/sb.094e2283.svg";